import { useState } from "react";

function useSelection<T>(data?: Array<{ id: T }>) {
  const [selection, setSelection] = useState<T[]>([]);

  const resetSelection = () => {
    setSelection([]);
  };

  const onSelectAll = () => {
    if (selection?.length === data?.length) {
      setSelection([]);
    } else {
      if (data) {
        setSelection(data.map(({ id }) => id));
      }
    }
  };

  const onSelectItem = (id: T) => {
    if (selection.includes(id)) {
      setSelection((s) => s.filter((i) => i !== id));
    } else {
      setSelection((s) => [...s, id]);
    }
  };

  return { onSelectAll, onSelectItem, selection, resetSelection };
}

export default useSelection;
